// Virtual Showrooms — brand pages inside the Home shell.
import {
  SHOWROOM_CATEGORY_LABELS,
  type ShowroomCategory,
} from "@mattoboard/schemas";

export const SHOWROOMS_LABEL = "Showrooms";
/** Page content cap (both shells): the member layout otherwise stretches to the viewport. */
export const SHOWROOM_MAX_WIDTH = 1440;

/**
 * Showroom media is decorative, and an image or link is draggable by default —
 * a touch drag starting on one is claimed by the browser's drag and never
 * reaches the scroller. Applied at the page roots, so it can't reach the board
 * editor's sidebar, where drag-to-canvas is a real feature.
 */
export const NO_MEDIA_DRAG_SX = {
  "& img, & a": { WebkitUserDrag: "none" },
} as const;

/**
 * Footprint and hover lift shared by the directory grid's tiles (BrandCard and
 * the trailing BrandInquiryCard), so they stay the same size side by side.
 */
export const DIRECTORY_TILE_SX = {
  width: "100%",
  aspectRatio: "380 / 210",
  minHeight: 180,
  borderRadius: "16px",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
  },
  "&:focus-visible": {
    outline: "2px solid",
    outlineColor: "primary.main",
  },
} as const;

export const SHOWROOMS_ROUTE = "/home/showrooms";

export const SHOWROOMS_COLLECTION = "showrooms";

export const showroomHref = (slug: string) => `${SHOWROOMS_ROUTE}/${slug}`;

/**
 * The public (anonymous) twin of the routes above. Same pages, rendered by
 * PublicShowroomShell instead of HomeLayout. This is the URL to hand to
 * brands: it works whether or not the visitor has an account.
 */
export const PUBLIC_SHOWROOMS_ROUTE = "/showrooms";

export const publicShowroomHref = (slug: string) =>
  `${PUBLIC_SHOWROOMS_ROUTE}/${slug}`;

/** Directory-card subtitle noun ("Paint · 1665 products"): the schema's labels, singular for paint. */
export const SHOWROOM_CATEGORY_CARD_LABELS: Record<ShowroomCategory, string> = {
  ...SHOWROOM_CATEGORY_LABELS,
  paints: "Paint",
};
